import React from 'react';

import ABaseColumn, {IColumnDefinition, IBaseColumnProps, Filter} from './BaseColumn';
import {Column} from './BasicDataGrid';
import {ISelectFieldProps, SelectedValue, OptionValue} from './SelectField';

interface ISelectFieldViewOnlyColumn extends ISelectFieldProps {
    dataDelimitter?: string;
    // disable some properties
    datasource?: undefined;
    disabled?: undefined;
    readonly?: undefined;
    onChange?: undefined;
}

export interface SelectFieldViewOnlyColumnPropsDefinition extends Column, ISelectFieldViewOnlyColumn {
}

interface ISelectFieldViewOnlyColumnPropsDefinition extends IColumnDefinition, ISelectFieldViewOnlyColumn {
}

interface ISelectFieldViewOnlyColumnProps extends IBaseColumnProps {
    /** information about the column, filled only in edit mode */
    column?: ISelectFieldViewOnlyColumnPropsDefinition;
}

// TODO XSVX001-200 This component is no longer used
// except in ColumnFactory, which should also be refactored
/**
 * SelectFieldViewOnlyColumn.
 * @author akirillov
 */
export default class SelectFieldViewOnlyColumn extends ABaseColumn<ISelectFieldViewOnlyColumnProps>
{
    /**
     * a column specific method to check data be valid on filter or not.
     *
     * If the value is an array the values will be concatenated by space and checked with basic implementation.
     * The value is converted to string by rendererKey if defined, otherwise by toString().
     *
     * Basic implementation looks for the exact words (case insensitive) with following special signs:
     * with + you can look for more than one word, ex. "Porsche+Auto" shows lines where Porsche and Auto are found.
     * with - you can exclude words, ex. "Jaguar -Auto" shows only lines with Jaguar but without Auto.
     * with | you can look for either one or another word, ex. "Porsche|Auto" shows lines where either Porsche or Auto (or both) are found.
     * with * you can replace the parts you don't know if the Filter.column.exactFiltering is set to false.
     *
     * @param filter filter
     * @param rowData row data to be checked for validness after filtering
     * @returns true if data is not filtered out, false otherwise
     */
    static filterValid(filter: Filter, rowData: any): boolean {
        const rowValue = rowData[filter.column.key];
        if (rowValue === undefined)
            return false;

        const column = filter.column as ISelectFieldViewOnlyColumnPropsDefinition;
        const {multi = false, rendererKey} = column;

        let sValue = '';
        if (multi && rowValue instanceof Array) {
            let sAllValues = '';
            rowValue.forEach(value => {
                const dispVal = rendererKey ? rendererKey(value) : value.toString();
                sAllValues = sAllValues.concat(' ' + dispVal);
            });
            sValue = sAllValues.trimLeft();
        }
        else {
            sValue = rendererKey ? rendererKey(rowValue) : rowValue.toString();
        }
        return ABaseColumn.filterValid(filter, {[filter.column.key]: sValue});
    }

    constructor(props: ISelectFieldViewOnlyColumnProps) {
        super(props);

        this.onChangeValue = this.onChangeValue.bind(this);
    }

    onChangeValue(selectedValue?: Array<SelectedValue> | OptionValue, selectedIndex?: number): void {
        let newValue;
        if (selectedValue instanceof Array) {
            newValue = selectedValue.map(value => value.selectedValue);
        }
        else {
            newValue = selectedValue;
        }
        this.onChange(newValue);
    }

    /**
     * custom rendering of value part
     * @param editMode rendering in edit mode or not
     */
    renderCustom(editMode: boolean) {
        const props: ISelectFieldViewOnlyColumn = {dataSource: []};
        Object.assign(props, this.state.column);
        let rendererKey = this.props.dependentValues ? this.props.dependentValues.column.rendererKey : undefined;
        if (props.multi && props.dataDelimitter) {
            let val = (this.state.value as string).split(props.dataDelimitter);
            if (val.length === 1 && val[0] === "")
                val = [];
        // multi value
            return (
                <div className="Select SelectField has-value is-clearable Select--multi">
                    <div className="Select-control">
                        <span className="Select-multi-value-wrapper">
                        {val.map((value, idx) => {
                                return (
                                    <div className="Select-value" key={idx}>
                                        <span className="Select-value-label">
                                            <div className="SelectField-Item-Value">{rendererKey ? rendererKey(value) : value}</div>
                                        </span>
                                    </div>
                                );
                        })}
                            <div className="Select-input" style={{display: "inline-block"}}>&nbsp;</div>
                        </span>
                    </div>
                </div>
                );
        }
        else {
        // single value
            return (
                <div className="Select SelectField has-value is-clearable Select--single">
                    <div className="Select-control">
                        <span className="Select-multi-value-wrapper">
                            <div className="Select-value">
                                <span className="Select-value-label" role="option">
                                    <div className="SelectField-Item-Value">{rendererKey ? rendererKey(this.state.value) : this.state.value}</div>
                                </span>
                            </div>
                            <div className="Select-input" style={{display: "inline-block"}}>&nbsp;</div>
                        </span>
                    </div>
                </div>
                );
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/SelectFieldViewOnlyColumn.tsx